import { Pipe, PipeTransform } from "@angular/core";
import { ellipsifyHtml } from "./ellipsify-html";

/**
 * Shortens a given html to a maximum length and adds an ellipsis at the end of it if the text exceeds the maximum length. Will preserve the html tags.
 * @param htmlToCut - The html to cut.
 * @param maxLength - The maximum length of the text (excluding tags).
 * @param ending - The string to add at the end of the text if it exceeds the maximum length. Default: "..."
 * @returns The shortened html with an ellipsis at the end if it exceeds the maximum length, otherwise the original html.
 */
@Pipe({ name: "ellipsifyHtml" })
export class EllipsifyHtmlPipe implements PipeTransform {
    public transform(htmlToCut: string = "", maxLength: number = 100, ending: string = "..."): string {
        return ellipsifyHtml(htmlToCut, maxLength, ending);
    }
}
